import React from 'react';
import { Badge } from '@skin-seoul/design-system';
export const CurrentProductBadge = () => {
  return <Badge backgroundColor="neutral.50" border="1px solid" borderColor="neutral.200" color="neutral.400" textStyle="paragraph.xsmall" fontWeight="medium" px="12px" py="6px" borderRadius="20px" data-sentry-element="Badge" data-sentry-component="CurrentProductBadge" data-sentry-source-file="CurrentProductBadge.tsx">
      Current Product
    </Badge>;
};